<template>
  <footer class="section_footer">
    <div class="block_glow_v3"></div>
    <div class="container_logo">
      <div class="stub"></div>
      <img src="@/assets/img/logo/logo.png" class="logo_footer" />
      <a href="#main" class="href_top_footer">
        <img src="@/assets/img/icon/up.svg" class="img_up" />
      </a>
    </div>
    <div class="section_nav_footer">
      <div class="container_nav_footer">
        <div class="box_nav_footer">
          <a href="#reviews" class="href_nav_footer">ОТЗЫВЫ</a>
          <a href="#calculator" class="href_nav_footer">КАЛЬКУЛЯТОР</a>
          <a href="#project" class="href_nav_footer">ПРОЕКТЫ</a>
          <a href="#catalog" class="href_nav_footer">КАТАЛОГ</a>
        </div>
        <div class="box_confidentiality_footer">
          <p class="confidentiality_text">©MebelDL 2024</p>
          <p class="confidentiality_text">Политика конфиденциальности</p>
        </div>
      </div>
      <div class="container_logo_m">
        <div class="stub"></div>
        <img src="@/assets/img/logo/logo.png" class="logo_footer" />
        <a class="href_top_footer">
          <img src="@/assets/img/icon/up.svg" class="img_up" />
        </a>
      </div>
      <div class="box_mti">
        <a
          href="https://mti-dev.ru/"
          target="_blank"
          class="confidentiality_text"
          >MTI-DEV</a
        >
      </div>
      <div class="container_social_footer">
        <div class="box_confidentiality_text">
          <p class="confidentiality_text">Пишите нам:</p>
          <div class="box_mti_m">
            <a
              href="https://mti-dev.ru/"
              target="_blank"
              class="confidentiality_text"
              >MTI-DEV</a
            >
          </div>
        </div>
        <div class="box_social_footer">
          <a href="https://t.me/KNemch" target="_blank" class="round_button">
            <img src="@/assets/img/icon/tg.png" class="tg_img" />
          </a>
          <a target="_blank" href="tel:89514002937" class="round_button">
            <img src="@/assets/img/icon/phone.png" class="phone_img" />
          </a>
          <a
            href="https://vk.com/nemchitsky"
            target="_blank"
            class="round_button"
          >
            <img src="@/assets/img/icon/vk.png" class="vk_img" />
          </a>
          <!-- <button class="button_footer" @click="toggleCart">
            <span>Оставить заявку</span>
          </button> -->
          <a href="https://mebel-klient.ru/" target="_blank" class="">
            <img
              src="@/assets/img/logo/mebel-klient.jpeg"
              class="mebel_klient_logo"
            />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { useCartStore } from "@/store/cartStore";

export default {
  setup() {
    const cartStore = useCartStore();

    return {
      toggleCart: cartStore.toggleCart,
    };
  },
};
</script>
<style scoped>
.box_mti_m {
  display: none;
}
.mebel_klient_logo {
  width: 7rem;
  height: auto;
}
.section_footer {
  position: relative;
  padding: 4rem 8rem 5rem 8rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  overflow: hidden;
}
.href_top_footer {
  border-radius: 4rem;
  background: linear-gradient(
    90deg,
    rgb(40, 37, 37) 0.01%,
    rgb(29, 27, 27) 102.467%
  );
  opacity: 0.5;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img_up {
  width: 1.2rem;
  height: 0.6rem;
  margin-bottom: 0.2rem;
  object-fit: cover;
}
.container_logo {
  display: flex;
  justify-content: space-between;
}
.stub {
  width: 3rem;
  height: 3rem;
}
.container_nav_footer {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  width: 25.5rem;
  justify-content: space-between;
}
.href_nav_footer {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: center;
  transition: 0.2s ease;
}
.box_nav_footer {
  display: flex;

  justify-content: space-between;
}
.href_nav_footer:hover {
  color: rgb(245, 160, 62);
  transition: 0.2s ease;
}
.confidentiality_text {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: -1%;
  text-align: left;
}
.box_confidentiality_footer {
  display: flex;
  justify-content: space-between;
}
.section_nav_footer {
  display: flex;
  justify-content: space-between;
}
.box_mti {
  display: flex;
  align-items: flex-end;
}
.container_social_footer {
  display: flex;
  flex-direction: column;
  gap: 2.1rem;
  width: 25.5rem;
}
.round_button {
  width: 2rem;
  height: 2rem;
  border: 0.1rem solid rgb(255, 255, 255);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tg_img {
  width: 1rem;
  height: 1rem;
  margin-right: 0.1rem;
}
.phone_img {
  width: 0.9rem;
  transform: rotate(-260deg);
}
.vk_img {
  width: 1.8rem;
  height: 1.8rem;
}
.box_social_footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.button_footer {
  border-radius: 4rem;

  background: linear-gradient(
    90deg,
    rgb(245, 160, 62),
    rgb(207, 117, 14) 102.477%
  );
  width: 9.75rem;
  height: 3rem;
  display: flex;
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}
.button_footer::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 204, 102, 0) 0%,
    rgba(255, 204, 102, 0.9) 50%,
    rgba(255, 204, 102, 0) 100%
  );
  filter: blur(4px);
  animation: wave 2s infinite linear;
  z-index: 0;
}

.button_footer span {
  color: rgb(255, 255, 255);
  position: relative;
  z-index: 1;
}
.block_glow_v3 {
  filter: blur(30rem);
  background: rgb(245, 160, 62);
  opacity: 0.2;
  width: 59.05rem;
  height: 59.05rem;
  position: absolute;
  top: -2rem;
  right: -2rem;
  z-index: -3;
}
.logo_footer {
  width: 4.95rem;
  /* height: 2.65rem; */
}
.container_logo_m {
  display: none;
}
@media (max-width: 767px) {
  .section_footer {
    padding: 2rem 2.4rem 2rem 2.4rem;
  }
  .container_nav_footer,
  .container_social_footer {
    width: 100%;
  }
  .section_nav_footer {
    flex-direction: column;
    gap: 3.2rem;
  }
  .container_logo {
    display: none;
  }
  .container_logo_m {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .box_mti {
    display: none;
  }
  .box_mti_m {
    display: flex;
  }
  .box_confidentiality_text {
    display: flex;
    justify-content: space-between;
  }
  .confidentiality_text {
    font-size: 0.71rem;
    font-weight: 400;
    line-height: 0.86rem;
  }
  .logo_footer {
    width: 7.07rem;
    /* height: 3.79rem; */
  }
  .block_glow_v3 {
    width: 30.43rem;
    height: 30.43rem;
    left: 12.79rem;
    top: 2rem;
    filter: blur(18.57rem);
    background: rgb(245, 160, 62);
    opacity: 0.2;
  }
}
</style>
